import { LogManager } from "@mcleod/core";
import { ImageName } from "@mcleod/images";
import { Image, Label, Layout, Panel, Toast } from "@mcleod/components";
import { DemoDefinition } from "../DemoDefinition";
import { DemoRegistry } from "../DemoRegistry";

const log = LogManager.getLogger("component-demo.dialogs.DemoToastDialog");

export class DemoToastDialog extends Layout {
    buttonShowToastOnClicked() {
        Toast.showToast("This is a basic toast created by providing only a string.");
    }

    buttonShowSuccessToastTitleOnClicked() {
        Toast.showSuccessToast("This is a basic success toast created by providing only a title.");
    }

    buttonShowSuccessToastOnClicked() {
        Toast.showSuccessToast("Success!", "This is a basic success toast created by providing a title, a message, and an image name.", ImageName.magnifyingGlass);
    }

    buttonShowCustomToastOnClicked() {
        const p = new Panel({ backgroundColor: "success" });
        p.add(new Image({ color: "#fff", name: ImageName.magnifyingGlass, height: 22, width: 22, rowBreak: false }));
        p.add(new Label({ color: "#fff", text: "This is a custom toast built in code." }));
        Toast.showToast(p, null, { persist: true });
    }

    buttonShowSuccessToastUserDismissedOnClicked() {
        Toast.showSuccessToast("Success!", "This is a basic success toast that must be dismissed by the user.", ImageName.magnifyingGlass, { persist: true });
    }

    buttonShowSuccessToastAutoDismissedOnClicked() {
        Toast.showSuccessToast("Success!", "This is a basic success toast that is automatically dismissed after 15 seconds.  If not specified, toasts are automatically dismissed after 7 seconds.", ImageName.magnifyingGlass, { millisUntilDismissal: 15000 });
    }

    buttonShowToastNoDuplicatesOnClicked() {
        Toast.showSuccessToast("Success!", "This is an example of a basic success toast that can only appear once at any given time.", ImageName.magnifyingGlass, { id: "sampleID", persist: true });
    }

    buttonShowSuccessToastOnDismissOnClicked() {
        Toast.showSuccessToast("Success!", "This is a basic success toast that prints a message to the console when it is dismissed.", ImageName.magnifyingGlass, { onDismiss: () => log.info("do something amazing"), persist: true });
    }
}
DemoRegistry.get().register(new DemoDefinition("dialogs/DemoToastDialog", [ "Dialogs", "Toast" ]));
